import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { Form, FormDate, FormInput } from '../../core/Formikfy';
import { Card } from '../Card/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import DeleteIcon from '@material-ui/icons/Delete';

const useStyles = makeStyles((theme) => ({
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  formInput: {
    margin: '10px',
  },
  contentHeading: {
    textAlign: 'left',
    fontSize: '1rem',
    fontWeight: 700,
    color: '#3C4858',
  },
  contentSubHeading: {
    textAlign: 'left',
    textTransform: 'uppercase',
    marginBottom: '20px',
    fontSize: '0.75rem',
    fontWeight: 400,
    color: '#999',
  },
}));

export const Education = (props) => {
  const classes = useStyles();
  const { isPublicView, deleteEducation, tileId } = props;
  const [tileIndex, setTileIndex] = useState(0);
  const [qualificationInfoOpen, setQualificationInfoOpen] = React.useState(false);

  const qualificationInfoHandleOpen = () => {
    setQualificationInfoOpen(true);
  };
  const qualificationInfoHandleClose = () => {
    setQualificationInfoOpen(false);
  };
  useEffect(() => {
    setTileIndex(tileId);
  }, []);

  return (
    <div style={{ position: 'relative' }}>
      {props.index !== 0 && <Divider variant="middle" style={{ marginBottom: '20px' }} />}
      <Grid container>
        <Grid item xs={10}>
          <Typography variant="h6" className={classes.contentHeading}>
            {props.item.title}
          </Typography>
          <Typography variant="h6" className={classes.contentSubHeading}>
            {props.item.yearFrom} to {props.item.yearTo}
          </Typography>
        </Grid>
        {!isPublicView && (
          <Grid item xs={2}>
            <IconButton color="default" onClick={qualificationInfoHandleOpen}>
              <EditIcon />
            </IconButton>
          </Grid>
        )}
        <Dialog
          open={qualificationInfoOpen}
          onClose={qualificationInfoHandleClose}
          aria-labelledby={props.item.title}
          aria-describedby={props.item.title}
        >
          <DialogTitle id={props.item.title}>Update Qualification</DialogTitle>
          <Form
            className={classes.form}
            initialValues={{
              title: props.item.title,
              yearFrom: props.item.yearFrom,
              yearTo: props.item.yearTo,
              // to: new Date(props.item.yearTo.seconds * 1000).toDateString(),
            }}
            onSubmit={(data) => {
              const newData = { title: data.title, yearFrom: data.yearFrom, yearTo: data.yearTo };
              props.educationUpdate(tileIndex, newData);
              qualificationInfoHandleClose();
            }}
          >
            <DialogContent>
              <DialogContentText>
                Enter your qualifications to display them in your Profile
              </DialogContentText>

              <div>
                <Card elevation={3} style={{ marginTop: '20px' }}>
                  <CardContent>
                    <FormInput
                      type="text"
                      label="Title"
                      name="title"
                      variant="standard"
                      fullWidth={true}
                      // onChange={e => handleInputChange(e, i)}
                    />
                    <Grid container>
                      <Grid item xs={6} style={{ paddingRight: '10px' }}>
                        <FormDate
                          label="From"
                          name="yearFrom"
                          variant="standard"
                          fullWidth={true}
                        />
                      </Grid>
                      <Grid item xs={6} style={{ paddingLeft: '10px' }}>
                        <FormDate label="To" name="yearTo" variant="standard" fullWidth={true} />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </div>
            </DialogContent>
            <DialogActions style={{ display: 'block' }}>
              <Button
                onClick={qualificationInfoHandleClose}
                color="primary"
                style={{ marginLeft: '10px' }}
              >
                Cancel
              </Button>
              <Button type="submit" color="primary" style={{ marginRight: '10px', float: 'right' }}>
                Update
              </Button>
              <IconButton
                style={{ right: '0', top: '0', position: 'absolute' }}
                color="primary"
                onClick={() => deleteEducation(tileIndex)}
              >
                <DeleteIcon />
              </IconButton>
            </DialogActions>
          </Form>
        </Dialog>
      </Grid>
    </div>
  );
};
